import React from "react";
import SEO from "../Components/SEO";
import Card2 from "../Images/Headers/publicity_2.jpg";
import "./Article.css";
import Breadcrumb from "react-bootstrap/Breadcrumb";

export function BaselineFuelConsumption() {
  return (
    <div className="art-page">
      <SEO
        title="Baseline Fuel Consumption Study — Gulu, Mbarara and Kampala Districts"
        description="In 2010, CIRCODU conducted Kitchen Performance Tests across three major Ugandan cities to establish national baseline fuel consumption data essential for carbon offset projects."
        keywords="baseline fuel consumption, kitchen performance test, carbon offset, cookstove, Gulu, Mbarara, Kampala, Uganda, carbon finance, emissions reduction, clean cooking, carbon project development, pre-intervention data, fuel use patterns, traditional stoves, carbon registries, CIRCODU, baseline study Uganda, fuel consumption study Uganda, kitchen performance test Uganda, carbon offset projects Uganda, cookstove monitoring Uganda"
        url="/Baseline-Fuel-Consumption-Study-Gulu-Mbarara-and-Kampala"
        datePublished="2010-06-01"
      />

      {/* ── Hero ──────────────────────────────────────── */}
      <div className="art-hero">
        <div className="art-hero__image">
          <img src={Card2} alt="News and Events Header" />
        </div>
        <div className="art-hero__overlay">
          <h4 className="art-hero__label">News &amp; Events</h4>
          <Breadcrumb>
            <Breadcrumb.Item className="text1" href="/">
              Home
            </Breadcrumb.Item>
            <Breadcrumb.Item className="text1">Publicity</Breadcrumb.Item>
            <Breadcrumb.Item
              className="text1"
              href="/publicity/news-and-events"
            >
              News &amp; Events
            </Breadcrumb.Item>
            <Breadcrumb.Item className="text1">
              Baseline Fuel Consumption Study — Gulu, Mbarara &amp; Kampala
              Districts
            </Breadcrumb.Item>
          </Breadcrumb>
        </div>
      </div>

      {/* ── Article body ──────────────────────────────── */}
      <section className="art-section border-bottom">
        <div className="container">
          <div className="art-content">
            <div className="art-date">
              <span className="art-date__dot" />
              June 01, 2010
            </div>
            <h1 className="art-title">
              Baseline Fuel Consumption Study — Gulu, Mbarara and Kampala
              Districts
            </h1>
            <div className="texty">
              <h2 className="art-subheading">Overview</h2>
              <p>
                In 2010, CIRCODU was engaged by the{" "}
                <strong>Uganda Carbon Bureau</strong> to conduct a national
                baseline fuel consumption study across three of Uganda's major
                cities: Gulu, Mbarara, and Kampala. The study was designed to
                establish reliable pre-intervention data on how much fuel
                households were consuming when cooking with traditional stoves —
                data essential for any credible carbon offset project seeking to
                quantify emissions reductions from improved cookstove adoption.
              </p>
              <p>
                In the world of carbon finance, baseline data is foundational.
                Without a credible, independently verified picture of fuel
                consumption before an intervention, it is impossible to
                calculate what emissions reductions a programme has genuinely
                achieved. This study provided exactly that foundation for
                Uganda's emerging clean cooking carbon sector.
              </p>
              <h2 className="art-subheading">CIRCODU's Role</h2>
              <p>
                CIRCODU deployed field teams to conduct{" "}
                <strong>Kitchen Performance Tests (KPTs)</strong> and kitchen
                surveys in households across the three study locations. These
                tests measured actual daily fuel consumption patterns under
                normal household cooking conditions, capturing the baseline
                against which future improvements could be measured.
              </p>
              <p>
                The <strong>three-city scope</strong> gave the study geographic
                breadth, spanning Uganda's northern (Gulu), western (Mbarara),
                and central (Kampala) regions and capturing meaningful variation
                in fuel types, stove technologies, and household cooking
                behaviour across different cultural and economic contexts. The
                data generated provided a statistically grounded baseline that
                carbon project developers could use to demonstrate additionality
                and calculate credible emissions reduction figures for
                submission to carbon registries.
              </p>
              <h2 className="art-subheading">Significance</h2>
              <p>
                Reliable baseline data is the bedrock of any carbon-financed
                cookstove programme. By conducting this study across three
                geographically and culturally distinct urban centres, CIRCODU
                helped establish a more representative and defensible picture of
                Uganda's pre-intervention cooking landscape, supporting the
                integrity of carbon offset claims in a sector where credibility
                was still being established.
              </p>
            </div>
            <div className="art-cta">
              <p>
                For more information about CIRCODU's baseline research and
                carbon monitoring services, contact us at{" "}
                <a href="mailto:info@circodu.org.ug">info@circodu.org.ug</a> or
                call <a href="tel:+256392004309">+256 (0) 392 004 309</a> /{" "}
                <a href="tel:+256782433627">+256 (0) 782 433 627</a>
              </p>
            </div>
            <a href="/publicity/news-and-events" className="art-back">
              ← Back to News &amp; Events
            </a>
          </div>
        </div>
      </section>
    </div>
  );
}
